/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {checkOvertimePrerequisites} from '../api'

export const useMutationCheckOvertimePrerequisites = createReactQueryMutationHook('checkOvertimePrerequisites', checkOvertimePrerequisites)
